const QuestionRedirect = ({ savedAnswer }) => {
  window.setTimeout(() => {
    window.location.href = savedAnswer;
  }, 5000);

  return null;
};

export default QuestionRedirect;
